import React, { Fragment } from 'react';
import { ieCheck  } from '../../../../helpers/utils';
import { CYOA_NETWORK_IDS } from '../../../../config';

const ProductCard = (props) => {

  const letterCount = (str) =>{
    return (str.length > 40) ? "small-text" : "";
  }

  const imageObj = {
    imageQuality:60,
    mapImages:props.data.fields.map.fields.file.url,
    mapPeople:props.data.fields.people.fields.file.url,
    mapHighlights:props.data.fields.highlightImages[0].fields.file.url
  }

  let productCurrency = "";
  let productPrice = "";

  if(props.data.fields.productsTMS !== undefined){
    productCurrency = (props.data.fields.productsTMS.prices_from.adult === "0.00") ? "" : "from " + props.data.fields.currency_mask;
    productPrice = (props.data.fields.productsTMS.prices_from.adult  === "0.00") ? "" : props.data.fields.productsTMS.prices_from.adult;
  }

  const standardImg = () => {
    return (
      <Fragment>
      <img
        alt=""
        data-srcset={`https:${imageObj.mapHighlights}?w=698&q=${imageObj.imageQuality} 1x,
        https:${imageObj.mapHighlights}?w=898&q=${imageObj.imageQuality} 2x`}
        data-src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
        className="lazyload original" />

        <img
          alt=""
          data-srcset={`https:${imageObj.mapImages}?w=698&q=${imageObj.imageQuality} 1x,
          https:${imageObj.mapImages}?w=898&q=${imageObj.imageQuality} 2x`}
          data-src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          className="lazyload hover-img" />
      </Fragment>
    )
  }

  const ieImg = () => {
    return (
      <img alt="" src={`https:${imageObj.mapHighlights}?w=698&q=${imageObj.imageQuality}`} />
    )
  }

  const tourOrCyoa = (props.data.fields.groupId === CYOA_NETWORK_IDS["europe"].id || props.data.fields.groupId === CYOA_NETWORK_IDS["usa"].id ) ? props.data.fields.webUrl : `/basket/${props.data.fields.tourId}`;

  

  return (
    <div className="columns small-12 medium-6 large-4">
      <a href={tourOrCyoa} className="search-product-card" onClick={ e => props.onProductClick(props.data.fields) }>
          <div className="row">
            <div className="columns small-12">

              <div className="search-product-card-img">

                { ieCheck() ? ieImg()  : standardImg() }


                <span className="search-product-day">
                  <span className="fa fa-sun-o"></span>{props.data.fields.duration} days
                </span>
                <span className="search-product-price">
                  {productCurrency}{productPrice}
                </span>
                {/* <div className="search-product-card-overlay"></div> */}
              </div>

            </div>
            <div className="columns small-12">
              <div className="search-product-content">
                <p className={`title ${letterCount(props.data.fields.name)}`}>{props.data.fields.name}</p>
              </div>
            </div>
        </div>
      </a>
     </div>
  )
}

export default ProductCard;



// WEBPACK FOOTER //
// ./src/components/search/components/products/product-card.js